import { Option } from '@vaaas/fpts/option';
import { h } from 'vue';
import styles from './index.module.scss';

export function ErrorPrinter(x: Option<Error>) {
    return x
        ? h('div', { class: styles.error }, x.message)
        : '';
}
